<template>
  <div>
      {{displayHours}}H {{displayMinutes}}M
  </div>
</template>

<script>
export default {
    props:["takePlace" , "year", "month", "day", "hour", "minute", "second", "milisecond", "clearInterval"],
    data(){
        return{
            displayDays:0,
            displayHours:0,
            displayMinutes:0,
            displaySeconds:0
        }
    },
    computed:{
        _seconds: () => 1000,
        _minutes(){
            return this._seconds * 60
        },
        _hours(){
            return this._minutes * 60
        },
        _days(){
            return this._hours * 24
        },
        end(){
            return new Date(
                this.year,
                this.month,
                this.day,
                this.hour,
                this.minute,
                this.second,
                this.milisecond
            );
        }
    },
    mounted(){
        this.showRemaining()
    },
    methods:{
        formatNum(num){
            num = num < 10 ? "0" + num : num
            
            return num
            
        },
        showRemaining(){
            const timer = setInterval(()=>{
                const now = new Date();
                const distance =  this.end.getTime() - now.getTime()
                
                if(distance<0){
                    if(this.takePlace == 'firstGame'){
                        this.$emit('timesUp' , this.end)
                    }
                    if(this.clearInterval)
                        clearInterval(timer)
                    return;
                }
                const days = Math.floor(distance / this._days)
                const hours = Math.floor((distance % this._days) / this._hours)
                const minutes = Math.floor((distance % this._hours) / this._minutes)
                const seconds = Math.floor((distance % this._minutes) / this._seconds)
                this.displayHours = this.formatNum(hours + (days * 24))
                this.displayMinutes = this.formatNum(minutes)
            }, 1000)
        }
    }

}
</script>

<style>

</style>